<template>
  <modal-container>
    <modal-default
      ref="modal"
      :title="`Duplicate ${typeLabelHeading}`"
      is-wide
    >
      <div class="modal-inner">
        <div class="fields-container mb-200">
          <grid-row :gap="2">
            <grid-column :size="6">
              <form-field-input
                label="Label"
                disabled=""
                :value="port.label || 'Unlabeled'"
              ></form-field-input>
            </grid-column>
            <grid-column :size="6">
              <form-field-input
                label="File"
                disabled=""
                :value="port.file_name"
              ></form-field-input>
            </grid-column>
          </grid-row>

          <grid-row :gap="2">
            <grid-column :size="6">
              <form-field-input
                label="Current Status"
                disabled=""
                :value="status"
              ></form-field-input>
            </grid-column>
            <grid-column :size="6">
              <form-field-input
                label="Created At"
                disabled=""
                :value="createdDate"
              ></form-field-input>
            </grid-column>
          </grid-row>
        </div>

        <import-validation-modal-warning-box
          :warnings="port.duplicates"
          title="Duplicates"
          :hint="`You have duplicate ${typeLabel} in your import file that was not imported.`"
        />
      </div>
    </modal-default>
  </modal-container>
</template>

<script>
import ImportValidationModalWarningBox from "./ImportValidationModalWarningBox.vue";
import dates from "../../../services/dates";
import {ENUMS} from "../../../services/enums";
import utils from "../../../services/utils";

export default {
  name: "ImportDuplicateModal",
  components: {ImportValidationModalWarningBox},
  props: {
    port: {
      type: Object,
      required: true
    },
  },
  computed: {
    status() {
      return utils.newGetEnumLabel(this.port.status, ENUMS.ImportStatusEnum)
    },
    typeLabelHeading() {
      return (this.port.type === ENUMS.ImportTypeEnum.Record.value) ? 'Leads' : 'Contacts'
    },
    typeLabel() {
      return (this.port.type === ENUMS.ImportTypeEnum.Record.value) ? 'leads' : 'contacts'
    },
    createdDate() {
      return dates.formatAsDateTime(this.port.created_at)
    },
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
  },
}
</script>

<style scoped lang="scss">

</style>
